export default {
  transactionsFilter: {
    filters: "Filters",
    applyFilter: "Apply Filter",
    depositFilterForm: {
      cryptoCurrency: "Cryptocurrency",
      currencyName: "Currency Name",
      ofDate: "From Date",
      tillDate: "To Date",
      status: "Status"
    },
    exchangeFilterForm: {
      fromCurrency: "From",
      currencyName: "Currency Name",
      toCryptoCurrency: "To",
      ofDate: "From Date",
      tillDate: "To Date",
      status: "Status"
    },
    filterForm: {
      time: "Time",
      defaultDate: {
        week: "Last Week",
        month: "Last Month",
        threeMonth: "Last Three Months"
      },
      fromDate: "From Date",
      tillDate: "To Date",
      status: "Status",
      currencyFilterInput: {
        cryptoCurrency: "Cryptocurrency",
        currencyName: "Currency Name",
        searchCryptoPlaceholder: "Search by cryptocurrency name or symbol",
        noCrypto: "No currency found"
      },
      fromToCurrenciesInput: {
        fromCryptoCurrency: "From",
        currencyName: "Currency Name",
        toCryptoCurrency: "To",
        searchInputPlaceholder: "Search by cryptocurrency name or symbol",
        noCrypto: "No currency found"
      },
      withdrawFilterForm: {
        cryptoCurrency: "Cryptocurrency",
        currencyName: "Currency Name",
        fromDate: "From Date",
        tillDate: "To Date",
        status: "Status"
      },
      submitButton: "Confirm"
    }
  },
  transactionDetail: {
    rialDeposit: "Rial Deposit",
    rialWithdrawal: "Rial Withdrawal",
    transactionDetails: "Transaction Details",
    depositCryptoDetail: {
      amount: "Deposited Amount",
      transactionId: "Transaction ID",
      date: "Date and Time",
      txid: "Transaction Hash (TXID)"
    },
    batchNumber: "Batch Number",
    voucherNumber: "Voucher",
    voucherCode: "Activation Code",
    voucherAmount: "Amount",
    depositRialDetail: {
      amount: "Deposited Amount",
      transactionId: "Transaction ID",
      type: "Type",
      online: "Online",
      offline: "Offline",
      date: "Date and Time",
      paymentInformation: "Payment Information",
      from: "Payment Gateway",
      trackingNumber: "Tracking Code",
      cardNumber: "Card Number",
      fromBank: "Source Bank",
      depositSystem: "Deposit Type"
    },
    exchangeDetail: {
      pay: "Pay",
      receive: "Receive",
      status: "Status",
      transactionId: "Transaction ID",
      date: "Date and Time",
      fee: "Fee"
    },
    offlinePaymentDetail: {
      amount: "Deposited Amount",
      date: "Date and Time",
      fromBank: "Source Bank",
      depositSystem: "Deposit Type",
      trackingNumber: "Tracking Code"
    },
    transferDetail: {
      transferred: "Transferred",
      transactionId: "Transaction ID",
      date: "Date and Time",
      description: "Description"
    },
    withdrawCryptoDetail: {
      amount: "Net Received Amount",
      transactionId: "Transaction ID",
      date: "Date and Time",
      fee: "Fee",
      grossAmount: "Gross Amount (including fee)",
      address: "Destination Wallet Address",
      txid: "Transaction Hash (TXID)",
      seeInDesc: "See in description",
      description: "Description"
    },
    withdrawRialDetail: {
      amount: "Withdrawn Amount",
      transactionId: "Transaction ID",
      date: "Date and Time",
      shebaNumber: "IBAN",
      trackingNumber: "Tracking Code",
      seeInDesc: "See in description",
      description: "Description"
    },
    cardNumber: "Card Number",
    datailsTitle: "Description"
  },
  depositTable: {
    filters: "Filters",
    clearAllFilters: "Clear Filters",
    all: "All",
    offline: "Offline",
    online: "Online",
    to: "To",
    from: "From",
    transactionId: "Transaction ID",
    depositAmount: "Deposited Amount",
    date: "Time",
    time: "Time",
    type: "Type",
    status: "Status",
    action: "Action",
    crypto: "Cryptocurrency",
    amount: "Amount"
  },
  detailsInTable: {
    details: "Details"
  },
  exchangeTable: {
    filters: "Filters",
    clearAllFilters: "Clear Filters",
    all: "All",
    from: "From",
    to: "To",
    transactionId: "Transaction ID",
    payment: "Payment",
    toCurrency: "To",
    executed: "Executed",
    date: "Time",
    time: "Time",
    status: "Status",
    action: "Action"
  },
  transferTable: {
    filters: "Filters",
    clearAllFilters: "Clear Filters",
    all: "All",
    from: "From",
    to: "To",
    crypto: "Cryptocurrency",
    amount: "Amount",
    transactionId: "Transaction ID",
    date: "Time",
    time: "Time",
    status: "Status",
    action: "Action"
  },
  verifyInTable: {
    pay: "Gateway",
    completeOrder: "Complete Order",
    smsConfirmation: "Identity Confirmation"
  },
  withdrawalTable: {
    filters: "Filters",
    clearAllFilters: "Clear Filters",
    all: "All",
    from: "From",
    to: "To",
    transactionId: "Transaction ID",
    withdrawalAmount: "Withdrawn Amount",
    date: "Time",
    time: "Time",
    status: "Status",
    action: "Action",
    crypto: "Cryptocurrency",
    amount: "Amount"
  },
  categories: [
    { to: "deposits", tooltip: "Deposits" },
    { to: "withdrawals", tooltip: "Withdrawals" },
    { to: "exchanges", tooltip: "Exchanges" },
    { to: "transfers", tooltip: "Transfers" }
  ]
};
